/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".margin-right[_ngcontent-%COMP%]{margin-right:30px}  cc-section{display:flex!important;flex-direction:column;padding:0!important}  cc-current-plan{margin-bottom:20px}.plan-section[_ngcontent-%COMP%]{display:flex;flex-direction:column}@media (min-width:1200px){.plan-section[_ngcontent-%COMP%]{flex-direction:row}  cc-section{padding:2rem!important}  cc-current-plan{flex:1;margin-right:30px;margin-bottom:0}  cc-webcall-balance{flex:1}  cc-phone-numbers-plan{flex:1}}"];
export { styles as styles };
